import { Component, Input } from '@angular/core';

import moment from 'moment-timezone';

import { I18nService } from '@core/i18n-legacy';
import type { JobSchedulerData } from '@core/offers-types';
import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

import { JobSchedulerErrorComponent } from '../job-scheduler-error/job-scheduler-error.component';

type TemplateData = {
  tooltipContent: string;
  content: string;
};
@Component({
  selector: 'rt-job-scheduler-info',
  templateUrl: './job-scheduler-info.component.html',
  styleUrls: ['./job-scheduler-info.component.less'],
  imports: [RtTooltip, IconComponent, JobSchedulerErrorComponent],
})
export class JobSchedulerInfoComponent {
  private readonly SDAY_FORMAT = 'DD MMM YYYY';

  @Input() public schedulerData!: JobSchedulerData;

  public translations: { [key: string]: string } = {};

  public get hasError(): boolean {
    return !!this.schedulerData?.error;
  }

  public get isPublishDate(): boolean {
    return !!this.schedulerData?.publishDate;
  }

  public get isCloseDate(): boolean {
    return !!this.schedulerData?.closeDate;
  }

  private get formattedPublishDate(): string {
    return this.schedulerData?.publishDate
      ? this.getFormattedDay(this.schedulerData.publishDate)
      : '';
  }

  private get formattedCloseDate(): string {
    return this.schedulerData?.closeDate ? this.getFormattedDay(this.schedulerData?.closeDate) : '';
  }

  constructor(private i18n: I18nService) {}

  public ngOnInit(): void {
    this.prepareTranslations();
  }

  public get templateData(): TemplateData {
    if (this.isPublishDate && !this.isCloseDate) {
      return {
        tooltipContent: this.translations.publishScheduled,
        content: this.formattedPublishDate,
      };
    }
    if (this.isCloseDate && !this.isPublishDate) {
      return {
        tooltipContent: this.translations.closeScheduled,
        content: this.formattedCloseDate,
      };
    } else {
      return {
        tooltipContent: this.translations.jobScheduled,
        content: `${this.formattedPublishDate} - ${this.formattedCloseDate}`,
      };
    }
  }

  private getFormattedDay(eventDate: string): string {
    return moment(eventDate).format(this.SDAY_FORMAT);
  }

  private prepareTranslations(): void {
    this.translations = {
      closeScheduled: this.i18n.translate('app.job_scheduler.schedule_info.close_scheduled', {
        closeAt: this.formattedCloseDate,
        timezone: this.schedulerData?.timezone,
      }),
      jobScheduled: this.i18n.translate('app.job_scheduler.schedule_info.job_scheduled', {
        closeAt: this.formattedCloseDate,
        publishAt: this.formattedPublishDate,
        timezone: this.schedulerData?.timezone,
      }),
      publishScheduled: this.i18n.translate('app.job_scheduler.schedule_info.publish_scheduled', {
        publishAt: this.formattedPublishDate,
        timezone: this.schedulerData?.timezone,
      }),
    };
  }
}
